import React from "react";

import dayjs from "dayjs";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import { usePartnerInfo } from "@utils";

import { Content } from "@ui/elements";
import { Stack } from "@ui/layout";

import { SubpageTemplate } from "@components";

import { LanguageSelect } from "../../components/LanguageSelect/LanguageSelect";
import { useTranslationContext } from "../../components/TranslationProvider";

import { en } from "./en";
import { hu } from "./hu";

const translations = {
  en: en,
  hu: hu,
};

export const TermsAndConditions = () => {
  const { locale } = useTranslationContext();
  const partnerInfo = usePartnerInfo();
  const { t } = useTranslation();

  const Component =
    translations[locale as keyof typeof translations] || translations.en;

  return (
    <SubpageTemplate>
      <Helmet>
        <title>
          {t("terms-and-conditions")} - {partnerInfo.name}
        </title>
      </Helmet>
      <Stack direction="column" justify="start" align="start">
        <LanguageSelect dropdownPlacement="bottom-start" />
        <Content>
          <Stack direction="column" gap="xxl">
            <Component
              country={t(partnerInfo.companyInfo.country)}
              company={partnerInfo.companyInfo.name}
              site={partnerInfo.url}
              phone={partnerInfo.companyInfo.phone}
              email={partnerInfo.contact.email}
              address={partnerInfo.companyInfo.address}
              city={partnerInfo.companyInfo.city}
              province={partnerInfo.companyInfo.province}
              postalCode={partnerInfo.companyInfo.postalCode}
              vatNumber={partnerInfo.companyInfo.vatNumber}
              lastUpdated={dayjs("2024-09-01").format("LL")}
              privacyPolicyLink={`${partnerInfo.url}/privacy-policy`}
              termsAndConditionsLink={`${partnerInfo.url}/terms-and-conditions`}
              cookiesLink={`${partnerInfo.url}/cookies`}
            />
          </Stack>
        </Content>
      </Stack>
    </SubpageTemplate>
  );
};
